import "../styles/slider.css";
import linkedin from "../images/linkedin_icon.png";
import { useContext } from "react";
import SliderContext from "./sliderContext";

function Slider() {
  const { sliderOpen, setSliderOpen } = useContext(SliderContext);
  const { sliderValue } = useContext(SliderContext);

  return (
    <div className={`overlay ${sliderOpen ? "visible" : ""}`}>
      <div className="transparent" onClick={() => setSliderOpen(false)} />
      <div className="slider">
        {sliderValue === "salisu" && <div className="heading">
          <div className="bg">
            <div className="close" onClick={() => setSliderOpen(false)} />
          </div>
          <div className="profile-pic" />
          <div className="name">
            <div>
              <h1>Salisu A. Abdullahi</h1>
              <img src={linkedin} alt="linkedin" />
            </div>
            <p>Chairman, Board of Directors</p>
          </div>
        </div>}
        {sliderValue === "sam" && <div className="heading">
          <div className="bg">
            <div className="close" onClick={() => setSliderOpen(false)} />
          </div>
          <div className={`profile-pic ${sliderValue === "sam" ? "sam" : ""}`} />
          <div className="name">
            <div>
              <h1>Samuel Anyanwu</h1>
              <img src={linkedin} alt="linkedin" />
            </div>
            <p>Managing Director & Co-founder</p>
          </div>
        </div>}
        {sliderValue === "russell" && <div className="heading">
          <div className="bg">
            <div className="close" onClick={() => setSliderOpen(false)} />
          </div>
          <div className={`profile-pic ${sliderValue === "russell" ? "russell" : ""}`} />
          <div className="name">
            <div>
              <h1>Russell Duru</h1>
              <img src={linkedin} alt="linkedin" />
            </div>
            <p>Deputy Managing Director & Co-founder</p>
          </div>
        </div>}
        {sliderValue === "salisu" && <div className="body">
          <h2>Profile</h2>
          <p>
            Salisu A. Abdullahi, Chairman - Board of Directors, BrandOne
            Technologies Limited. He is a veteran IT professional with
            experience in system design, development, implementation, operations
            and support. He served as the Senior Special Assistant on IT to the
            Government of Kano State and member of the ICT Technical Working
            Group of the National Integrated Infrastructure Master Plan (NIIMP).
            He is currently serves an executive in a number of organisations.
          </p>
          <h2>Professional background</h2>
          <p>
            The chairman has served meritoriously in various capacities for a
            number of national and international bodies including: National
            President, Zumunta Association USA, National Assistance Secretary,
            Nigerian Information Technology Professionals in America (NITPA),
            Former Board Member, Nigerians in Diaspora Organization (NIDO)
            Americas, Member, Black Data Processing Associate (BDPA).
          </p>
          <h2>Achievements</h2>
          <p>
            The chairman's vision to deliver state of the art technology
            initiated a study tour for a 15-man delegation to Silicon Valley,
            California, USA, under the leadership of the Governor of Kano State.
            The initiative opened the gates for Bill Gate's first trip to
            Nigeria to aid the efforts in the eradication of polio in the
            country. The chairman has also coordinated management and IT
            workshops for senior management in the public and private sectors
            including NNPC, CBN, FIRS and FERMA.
          </p>
          <h2>Education</h2>
          <p>
            Salisu A. Abdullahi graduated from the University of New Haven,
            Connecticut, USA, with Bachelors and Masters awards in Business Data
            processing and Computer Information Science. He held various
            teaching, technical and managerial positions in the United States
            including Director, Business Development, Essex Management Centre
            (EMC), Essex, Connecticut, USA.
          </p>
        </div>}
        {sliderValue === "sam" && <div className="body">
          <h2>Profile</h2>
          <p>
            Samuel Anyanwu Co-founded BrandOne Technologies Limited With a group
            of Technocrats, he has over 15 years of solid experience in Banking,
            Management and Leadership, Business Development, Information and
            Communication Technology.
          </p>
          <h2>Professional background</h2>
          <p>
            As a Presales Manager, he joined InfoTech Ltd, a subsidiary of Royal
            Heads Limited Ikeja, in 2000. He later joined Global Computers Ltd
            in 2003 as Operations Manager before joining Citizens Intl Bank Ltd
            in 2002 as a Trainee Banking Officer, where he managed the branch's
            Funds Transfer and Treasury Operations Units for eighteen (18)
            months before being promoted to an Assistant Banking Officer. He
            also worked in the Customer Service Unit (CSU), Cash & Teller, and
            Credit & Marketing Units at various times. Due to his extensive
            knowledge of the branch operations, he was appointed as Head of
            Operations in 2005. He also collaborated with the Head Office
            Information management system department (IMSD), managed the
            branch's IT issues, and was well versed in the administration and
            use of Finacle and Globus core banking applications. During this
            time, he made an outstanding impression on his colleagues in the
            Branch and the Bank as a whole, and he was promoted to the rank of
            Banking Officer. He resigned in 2007 to join Red Baron International
            Lagos as General Manager Operations, a position he held for two
            years before joining Options Group as Director of Operations, where
            he oversaw the operations of both Options Technologies Ltd and
            Diskovery Limited. Options Technologies Limited is a Lagos-based
            information and communication technology company. Preferred Partners
            include HP, IBM, and Oracle.
          </p>
          <h2>Achievements</h2>
          <p>
            With unwavering dedication and a commitment to excellence, Samuel
            Anyanwu has fostered BrandOne Technologies into his most cherished
            accomplishment. As the Managing Director, He serves on the boards of
            several companies. He also serves on the Governing Council of the
            Institute of Enterprise Management (IEMA). He has received training
            in Nigeria and abroad in electronic document management, new product
            development, cloud computing, payments and collections solutions, HR
            and Manpower development, leadership, strategic management, and
            business administration.
          </p>
          <h2>Leadership style</h2>
          <p>
            Samuel Anyanwu a visionary approach and a steadfast commitment to
            innovation, has steered the company to new heights in the tech
            industry. His exceptional leadership skills have not only propelled
            BrandOne Technologies to the forefront but have also fostered a
            culture of excellence, driving the team to consistently deliver
            cutting-edge solutions and services.
          </p>
          <h2>Vision for the company</h2>
          <p>
            Samuel Anyanwu envisions a future for BrandOne Technologies where
            the company's vision is to be a first-class hub for enterprise
            solutions, relied on by organizations, in and around the world to
            drive their business processes and its mission to provide clients
            with world class enterprise technologies and bespoke business
            solutions that will help them increase efficiency, productivity and
            have competitive advantage.
          </p>
          <h2>Education</h2>
          <p>
            He has a Background in Geoscience and an MBA (In-V); He also
            possesses certifications in Computer Science (Diploma), Strategic
            management, leadership: Identity, Influence and Power from Open
            University of Australia (OUA).
          </p>
        </div>}
        {sliderValue === "russell" && <div className="body">
          <h2>Profile</h2>
          <p>
            Russell Duru, co-founded BrandOne Technologies Limited. A visionary
            tech leader propelling BrandOne Technologies Limited to enduring
            success and unprecedented growth. He co-founded BrandOne
            Technologies with a group of other technocrats having spent over
            20yrs in tech with rich hands-on in technology, leadership, project
            management, business development, R & D.
          </p>
          <h2>Professional background</h2>
          <p>
            With a remarkable career spanning over two decades, Russell Duru has
            accrued invaluable experience in the technology industry. Prior to
            co-founding BrandOne Technologies, he worked with Time Computers &
            Information Technologies Ltd as a System Analyst, Urbane Information
            System Ltd as System Engineer, Petrodata Management Services Ltd as
            a Systems Analyst before being promoted to Manager ICT, Enterprise
            Bank Ltd and later Fleet Technologies Ltd (now Vatebra) as a Senior
            Manager Business Development.
          </p>
          <h2>Achievements</h2>
          <p>
            Russell Duru's tenure at BrandOne Technologies Limited has been
            marked by a series of significant accomplishments that have
            substantially contributed to the company's sterling reputation and
            continued success. Some of these notable achievements include
            spearheading major projects, facilitating market expansion, and
            achieving key milestones that have propelled BrandOne to new heights
            in the technology landscape. He managed various complex solutions
            for these companies and helped to open up new businesses that helped
            to increase the revenues of these organizations by over 75%.
          </p>
          <h2>Leadership style</h2>
          <p>
            Recognized for his pragmatic and innovative leadership style,
            Russell Duru is celebrated for fostering a culture of collaboration,
            knowledge transfer and creativity within BrandOne Technologies. He
            possesses the unique ability to inspire and draw out the best from
            the company's talented teams, resulting in high levels of innovation
            and excellence.
          </p>
          <h2>Vision for the company</h2>
          <p>
            Russell Duru envisions a future for BrandOne Technologies where the
            company's vision is to be a first-class hub for enterprise
            solutions, relied on by organizations, in and around the world to
            drive their business processes and its mission to provide clients
            with world class enterprise technologies and bespoke business
            solutions that will help them increase efficiency, productivity and
            have competitive advantage. He is also taken the vision further by
            having BrandOne incorporate a subsidiary company that will provide
            SuperApps that will be used for payments, medicare, travels and
            more.
          </p>
          <h2>Education</h2>
          <p>
            He has a background in Computer Science, Masters in Computers System
            and an MBA in International Business and also possess a certificate
            in Managerial Leadership in Sales and Marketing and Project
            Management from the prestigious Lagos Business School (LBS). He
            equally possesses tech certifications in Cisco, Oracle and project
            management. He belongs to various professional organization like
            Nigeria Computer Society, Computer Professional Registration Council
            of Nigeria, Institute of Strategic Management Nigeria and Institute
            of Software Practitioners of Nigeria. Russell Duru's extensive
            experience, visionary leadership, and educational background has
            made him an exceptional asset to BrandOne Technologies Limited. As
            the DMD, he continues to drive the company to new heights, shaping
            its future with unwavering dedication and a keen eye for innovation,
            partnership and excellent customer service in the tech industry.
          </p>
        </div>}
      </div>
    </div>
  );
}

export default Slider;
